<template>
    <section class="inner_banner">
        <div class="container">
            <h2 class="title">Blog</h2>
            <div class="blog">
                <article class="row">
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog1.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog2.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog3.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog1.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog2.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog3.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog1.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog2.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog3.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog1.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog2.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-lg-4 col-md-6">
                        <div class="blog_inner">
                            <router-link to="blog-detail"><img src="../assets/images/blog3.jpg" alt=""></router-link>
                            <div class="blog_inner_text">
                                <h4>Lorem ipsum dolor sit amet</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent. </p>
                                <router-link to="blog-detail">Read More</router-link>
                            </div>
                        </div>
                    </aside>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Blog"
}
</script>

<style scoped>

</style>
